// removed by extract-text-webpack-plugin
module.exports = {"discover":"qempo_Discover_discover-1PJPQa_","green":"qempo_Discover_green-lnY9H4h","circleAndPlay":"qempo_Discover_circleAndPlay-wmdmT2c","white":"qempo_Discover_white-3n50Jhb","lightBlue":"qempo_Discover_lightBlue-2M9mCbX","orange":"qempo_Discover_orange-322a9M4","hasIcon":"qempo_Discover_hasIcon-3lNt1lf","title":"qempo_Discover_title-2o0EEBN","buttonWrap":"qempo_Discover_buttonWrap-5QX6E8Y","iframe":"qempo_Discover_iframe-3g5VC68","close":"qempo_Discover_close-1wyg4bY","blink":"qempo_Discover_blink-1cnjS2-"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/elements/Discover/Discover.scss
// module id = 691
// module chunks = 0